module.exports = __webpack_public_path__ + "img/bgCopyID.63d67de7.png";